<template>
  <div class="flex w-full flex-col gap-4">
    <!-- Mobile Menu -->
    <div class="overflow-x-auto md:hidden">
      <PrimeCarousel
        :value="items"
        :num-visible="2"
        :num-scroll="1"
        :circular="false"
        :responsive-options="responsiveOptions"
        class="settings-carousel"
      >
        <template #item="slotProps">
          <div class="flex justify-center p-1">
            <PrimeButton
              :text="showComponent !== slotProps.data.label"
              :outlined="showComponent !== slotProps.data.label"
              :severity="
                showComponent === slotProps.data.label ? 'primary' : 'contrast'
              "
              class="w-fit whitespace-nowrap"
              @click="showComponent = slotProps.data.label"
            >
              <span :class="slotProps.data.icon" class="mr-2" />
              {{ $t(`components.settings.menu.${slotProps.data.label}`) }}
            </PrimeButton>
          </div>
        </template>
      </PrimeCarousel>
    </div>

    <!-- Mobile Content -->
    <div class="overflow-x-hidden py-4 md:hidden">
      <component :is="showComponent" />
    </div>

    <!-- Desktop Menu -->
    <div class="hidden gap-2 overflow-y-hidden md:flex">
      <PrimeMenu
        :model="items"
        class="h-fit w-fit"
        style="border: none; min-width: fit-content"
      />
      <PrimeDivider layout="vertical" />
      <div class="max-h-[320px] w-full overflow-y-auto py-8">
        <component :is="showComponent" />
      </div>
    </div>
  </div>
</template>

<script>
import General from './components/General.vue';
import Security from './components/Security.vue';
import Profile from './components/Profile.vue';
import Email from './components/Email.vue';

export default defineNuxtComponent({
  components: {
    General,
    Security,
    Profile,
    Email,
  },
  emits: ['update:showComponent'], // emit'i tanımlayın

  data() {
    return {
      showComponent: 'Profile',
      items: [
        // {
        //   label: "General",
        //   icon: "pi pi-cog",
        //   command: () => {
        //     this.showComponent = "General";
        //   },
        // },
        {
          label: 'profile',
          icon: 'pi pi-user',
          command: () => {
            this.showComponent = 'Profile';
          },
        },
        {
          label: 'email',
          icon: 'pi pi-envelope',
          command: () => {
            this.showComponent = 'Email';
          },
        },
        {
          label: 'security',
          icon: 'pi pi-shield',
          command: () => {
            this.showComponent = 'Security';
          },
        },
      ],
      responsiveOptions: [
        {
          breakpoint: '767px',
          numVisible: 3,
          numScroll: 1,
        },
        {
          breakpoint: '500px',
          numVisible: 2,
          numScroll: 1,
        },
      ],
    };
  },
  watch: {
    showComponent(newValue) {
      this.$emit('update:showComponent', newValue);
    },
  },
});
</script>

<style scoped>
:deep(.p-menu-list, .p-menu-item, .p-menu-item-content) {
  width: fit-content; /* İsterseniz gösterge noktalarını gizleyebilirsiniz */
}
/* Carousel özelleştirmeleri */
:deep(.settings-carousel .p-carousel-indicators) {
  display: none; /* İsterseniz gösterge noktalarını gizleyebilirsiniz */
}

:deep(.settings-carousel .p-carousel-content) {
  padding: 0;
}

:deep(.settings-carousel .p-carousel-container) {
  padding: 0;
}

/* Carousel navigasyon butonlarını özelleştirme */
:deep(.settings-carousel .p-carousel-prev),
:deep(.settings-carousel .p-carousel-next) {
  width: 2rem;
  height: 2rem;
  color: var(--primary-color);
}
</style>
